<script setup lang="ts">
import DocumentViewer from '@/components/document/DocumentViewer.vue'
import { ref } from 'vue'

const docUrl = ref(
  'https://d1bnvx5vhcnf8w.cloudfront.net/curriculum/Oct%202020%20%28Edition%205%29/General/edition_5_-_general_english_g6.pdf',
)
</script>

<template>
  <div class="doc-page">
    <DocumentViewer :doc-path="docUrl" />
  </div>
</template>

<style lang="scss" scoped>
.doc-page {
  width: 100%;
  height: 100%;
  position: relative;
}

.dark .loadding-wrapper {
  color: rgba(#fff, 0.8);
}
</style>
